import isEmpty from 'lodash/isEmpty';

const mapFullSchedule = (schedule, semesterDays, semesterClasses) => {
    const parsedGroupList = schedule.map(({ group }) => group);
    const parsedResultArray = [];

    semesterDays.forEach((day) => {
        const tempClassesArray = [];
        semesterClasses.forEach((classItem) => {
            const tepmOddCardsArray = [];
            const tempEvenCardsArray = [];
            parsedGroupList.forEach((groupItem) => {
                const groupFull = schedule.find(
                    (groupFullIterate) => groupFullIterate.group.id === groupItem.id,
                );
                if (!groupFull) {
                    tepmOddCardsArray.push({ group: groupItem, card: null });
                    tempEvenCardsArray.push({ group: groupItem, card: null });
                    return;
                }
                const dayFull = groupFull.days.find((dayFullIterate) => dayFullIterate.day === day);
                if (!dayFull) {
                    tepmOddCardsArray.push({ group: groupItem, card: null });
                    tempEvenCardsArray.push({ group: groupItem, card: null });
                    return;
                }
                const classFull = dayFull.classes.find(
                    (dayFullIterable) => dayFullIterable.class.id === classItem.id,
                );
                tepmOddCardsArray.push({
                    group: groupItem,
                    card: classFull ? classFull.weeks.odd : null,
                });
                tempEvenCardsArray.push({
                    group: groupItem,
                    card: classFull ? classFull.weeks.even : null,
                });
            });
            tempClassesArray.push({
                class: classItem,
                cards: { odd: tepmOddCardsArray, even: tempEvenCardsArray },
            });
        });
        parsedResultArray.push({ day, classes: tempClassesArray });
    });

    return { parsedGroupList, parsedResultArray };
};

export const makeFullSchedule = (fullSchedule) => {
    // A semester kept by date answers with dates, periods and what is on them, and has no pair of
    // weeks to split into. It travels through untouched for the view to render as a calendar;
    // `dates` is what tells the two apart.
    if (fullSchedule?.dates) {
        return { semester: fullSchedule.semester, byDate: fullSchedule };
    }

    const { schedule, semester } = fullSchedule;
    const groupsCount = schedule?.length || 0;
    const semesterDays = semester?.semester_days || [];
    const semesterClasses = semester?.semester_classes || [];
    let groupList = [];
    let resultArray = [];

    if (!isEmpty(schedule)) {
        const { parsedGroupList, parsedResultArray } = mapFullSchedule(
            schedule,
            semesterDays,
            semesterClasses,
        );
        groupList = parsedGroupList;
        resultArray = parsedResultArray;
    }

    return {
        semester,
        schedule,
        semesterClasses,
        semesterDays,
        groupsCount,
        groupList,
        resultArray,
    };
};
